var languages = {
	"nb-NO": [
		{
			"resourceKey": "app.absenceText",
			"cultureCode": "nb-NO",
			"value": "Fravær"
		},
		{
			"resourceKey": "app.actionsHeading",
			"cultureCode": "nb-NO",
			"value": "Handlinger"
		},
		{
			"resourceKey": "app.add",
			"cultureCode": "nb-NO",
			"value": "Legg til"
		},
		{
			"resourceKey": "app.amountText",
			"cultureCode": "nb-NO",
			"value": "Antall"
		},
		{
			"resourceKey": "app.apiTimeoutTitle",
			"cultureCode": "nb-NO",
			"value": "Tidsavbrudd"
		},
		{
			"resourceKey": "app.btnAdd",
			"cultureCode": "nb-NO",
			"value": "Legg til"
		},
		{
			"resourceKey": "app.btnAskAbsence",
			"cultureCode": "nb-NO",
			"value": "Søk fravær"
		},
		{
			"resourceKey": "app.btnDelete",
			"cultureCode": "nb-NO",
			"value": "X"
		},
		{
			"resourceKey": "app.btnEdit",
			"cultureCode": "nb-NO",
			"value": "Rediger"
		},
		{
			"resourceKey": "app.btnRegisterHours",
			"cultureCode": "nb-NO",
			"value": "Registrer tid"
		},
		{
			"resourceKey": "app.btnRegisterHoursIn",
			"cultureCode": "nb-NO",
			"value": "Inn"
		},
		{
			"resourceKey": "app.btnRegisterHoursOut",
			"cultureCode": "nb-NO",
			"value": "Ut"
		},
		{
			"resourceKey": "app.btnSave",
			"cultureCode": "nb-NO",
			"value": "Lagre"
		},
		{
			"resourceKey": "app.btnSendMessage",
			"cultureCode": "nb-NO",
			"value": "Send melding"
		},
		{
			"resourceKey": "app.btnShow",
			"cultureCode": "nb-NO",
			"value": "Detaljer"
		},
		{
			"resourceKey": "app.cancel",
			"cultureCode": "nb-NO",
			"value": "Avbryt"
		},
		{
			"resourceKey": "app.checkAll",
			"cultureCode": "nb-NO",
			"value": "Merk alle"
		},
		{
			"resourceKey": "app.close",
			"cultureCode": "nb-NO",
			"value": "Lukk"
		},
		{
			"resourceKey": "app.confirmDeletionTitle",
			"cultureCode": "nb-NO",
			"value": "Bekreft sletting?"
		},
		{
			"resourceKey": "app.currentDateText",
			"cultureCode": "nb-NO",
			"value": "Valgt dato"
		},
		{
			"resourceKey": "app.dateText",
			"cultureCode": "nb-NO",
			"value": "Dato"
		},
		{
			"resourceKey": "app.dayText",
			"cultureCode": "nb-NO",
			"value": "Dag"
		},
		{
			"resourceKey": "app.delete",
			"cultureCode": "nb-NO",
			"value": "Slett"
		},
		{
			"resourceKey": "app.departmentText",
			"cultureCode": "nb-NO",
			"value": "Avdeling"
		},
		{
			"resourceKey": "app.description",
			"cultureCode": "nb-NO",
			"value": "Beskrivelse"
		},
		{
			"resourceKey": "app.detailsTitle",
			"cultureCode": "nb-NO",
			"value": "Detaljer"
		},
		{
			"resourceKey": "app.dutyText",
			"cultureCode": "nb-NO",
			"value": "Vakt"
		},
		{
			"resourceKey": "app.dutyWishPeriodsText",
			"cultureCode": "nb-NO",
			"value": "Periodevaktønske"
		},
		{
			"resourceKey": "app.dutyWishText",
			"cultureCode": "nb-NO",
			"value": "Ønske om ekstravakt"
		},
		{
			"resourceKey": "app.false",
			"cultureCode": "nb-NO",
			"value": "Nei"
		},
		{
			"resourceKey": "app.forgotPasswordInfoText",
			"cultureCode": "nb-NO",
			"value": "Velg firma og skriv inn din e-postadresse for å bestille instruksjoner for å resette passordet ditt."
		},
		{
			"resourceKey": "app.forgotPasswordQuestion",
			"cultureCode": "nb-NO",
			"value": "Glemt passordet?"
		},
		{
			"resourceKey": "app.forgotPasswordRequestedText",
			"cultureCode": "nb-NO",
			"value": "Vi har sendt deg en e-post med en lenke for å resette passordet ditt. Hvis du ikke mottar den innen noen få minutter bør du sjekke spam-mappen din."
		},
		{
			"resourceKey": "app.fromDateLabel",
			"cultureCode": "nb-NO",
			"value": "Fra dato"
		},
		{
			"resourceKey": "app.fromTime",
			"cultureCode": "nb-NO",
			"value": "Fra klokka"
		},
		{
			"resourceKey": "app.hoursAndExtraRates",
			"cultureCode": "nb-NO",
			"value": "Timer og tillegg"
		},
		{
			"resourceKey": "app.hoursText",
			"cultureCode": "nb-NO",
			"value": "Timer"
		},
		{
			"resourceKey": "app.informationText",
			"cultureCode": "nb-NO",
			"value": "Informasjon"
		},
		{
			"resourceKey": "app.informationTitle",
			"cultureCode": "nb-NO",
			"value": "Informasjon"
		},
		{
			"resourceKey": "app.licenseInvalidText",
			"cultureCode": "nb-NO",
			"value": "Ugyldig systemlisens."
		},
		{
			"resourceKey": "app.licenseTitle",
			"cultureCode": "nb-NO",
			"value": "Lisensinfo"
		},
		{
			"resourceKey": "app.loading",
			"cultureCode": "nb-NO",
			"value": "Min Capitech laster…"
		},
		{
			"resourceKey": "app.login.btnLogin",
			"cultureCode": "nb-NO",
			"value": "Logg inn"
		},
		{
			"resourceKey": "app.login.placeholderPassword",
			"cultureCode": "nb-NO",
			"value": "Passord"
		},
		{
			"resourceKey": "app.login.placeholderUsername",
			"cultureCode": "nb-NO",
			"value": "Brukernavn"
		},
		{
			"resourceKey": "app.login.rememberLogin",
			"cultureCode": "nb-NO",
			"value": "Husk innlogging"
		},
		{
			"resourceKey": "app.messagesText",
			"cultureCode": "nb-NO",
			"value": "Meldinger"
		},
		{
			"resourceKey": "app.messageText",
			"cultureCode": "nb-NO",
			"value": "Melding"
		},
		{
			"resourceKey": "app.my",
			"cultureCode": "nb-NO",
			"value": "Min"
		},
		{
			"resourceKey": "app.name",
			"cultureCode": "nb-NO",
			"value": "Min Capitech"
		},
		{
			"resourceKey": "app.no",
			"cultureCode": "nb-NO",
			"value": "Nei"
		},
		{
			"resourceKey": "app.noOptionToChoose",
			"cultureCode": "nb-NO",
			"value": "Ingen mulige valg"
		},
		{
			"resourceKey": "app.notes",
			"cultureCode": "nb-NO",
			"value": "Notat"
		},
		{
			"resourceKey": "app.noticeText",
			"cultureCode": "nb-NO",
			"value": "Merknad/kommentar"
		},
		{
			"resourceKey": "app.openFilter",
			"cultureCode": "nb-NO",
			"value": "Åpne filter"
		},
		{
			"resourceKey": "app.planNumberText",
			"cultureCode": "nb-NO",
			"value": "Plannummer"
		},
		{
			"resourceKey": "app.pleaseSelect",
			"cultureCode": "nb-NO",
			"value": "Vennligst velg…"
		},
		{
			"resourceKey": "app.registerText",
			"cultureCode": "nb-NO",
			"value": "Registrer"
		},
		{
			"resourceKey": "app.returnToSignInQuestion",
			"cultureCode": "nb-NO",
			"value": "Gå til innlogging?"
		},
		{
			"resourceKey": "app.sendPasswordResetEmailButtonText",
			"cultureCode": "nb-NO",
			"value": "Send passord reset e-post"
		},
		{
			"resourceKey": "app.settings.labelApiUrl",
			"cultureCode": "nb-NO",
			"value": "API-adresse"
		},
		{
			"resourceKey": "app.settings.labelLanguage",
			"cultureCode": "nb-NO",
			"value": "Språk"
		},
		{
			"resourceKey": "app.settings.saveButton",
			"cultureCode": "nb-NO",
			"value": "Lagre innstillinger"
		},
		{
			"resourceKey": "app.settings.settingsDescription",
			"cultureCode": "nb-NO",
			"value": "Her stilles applikasjonen inn etter ønsket oppsett, trenger du hjelp ta kontakt med <a href=\"http://support.capitech.no\" target=\"_blank\">Capitech support</a>."
		},
		{
			"resourceKey": "app.settings.settingsText",
			"cultureCode": "nb-NO",
			"value": "Innstillinger"
		},
		{
			"resourceKey": "app.settings.settingsTitle",
			"cultureCode": "nb-NO",
			"value": "Dine app-<strong>innstillinger</strong>"
		},
		{
			"resourceKey": "app.settings.validationText",
			"cultureCode": "nb-NO",
			"value": "Terminalen ble validert og du kan begynne å bruke den."
		},
		{
			"resourceKey": "app.settings.validationTitle",
			"cultureCode": "nb-NO",
			"value": "Validering vellykket!"
		},
		{
			"resourceKey": "app.settingsBtn",
			"cultureCode": "nb-NO",
			"value": "Innstillinger"
		},
		{
			"resourceKey": "app.statusText",
			"cultureCode": "nb-NO",
			"value": "Status"
		},
		{
			"resourceKey": "app.systemErrorMsg",
			"cultureCode": "nb-NO",
			"value": "En ukjent systemfeil oppstod, hvis feilen gjenntar seg kontakt systemansvarlig."
		},
		{
			"resourceKey": "app.systemErrorTitle",
			"cultureCode": "nb-NO",
			"value": "Systemfeil"
		},
		{
			"resourceKey": "app.textText",
			"cultureCode": "nb-NO",
			"value": "Tekst"
		},
		{
			"resourceKey": "app.timeoutErrorMsg",
			"cultureCode": "nb-NO",
			"value": "Et tidsavbrudd oppstod, vennligst prøv igjen."
		},
		{
			"resourceKey": "app.timeoutErrorTitle",
			"cultureCode": "nb-NO",
			"value": "Tidsavbrudd"
		},
		{
			"resourceKey": "app.timeText",
			"cultureCode": "nb-NO",
			"value": "Tid"
		},
		{
			"resourceKey": "app.toDateLabel",
			"cultureCode": "nb-NO",
			"value": "Til dato"
		},
		{
			"resourceKey": "app.toTime",
			"cultureCode": "nb-NO",
			"value": "Til klokka"
		},
		{
			"resourceKey": "app.true",
			"cultureCode": "nb-NO",
			"value": "Ja"
		},
		{
			"resourceKey": "app.tryAgainBtn",
			"cultureCode": "nb-NO",
			"value": "Prøv igjen"
		},
		{
			"resourceKey": "app.typenameAbscense",
			"cultureCode": "nb-NO",
			"value": "Fravær"
		},
		{
			"resourceKey": "app.typenameAvailableDuty",
			"cultureCode": "nb-NO",
			"value": "Ledig vakt"
		},
		{
			"resourceKey": "app.typenameDutyWish",
			"cultureCode": "nb-NO",
			"value": "Vaktønske"
		},
		{
			"resourceKey": "app.typenamePlannedDuty",
			"cultureCode": "nb-NO",
			"value": "Planlagt vakt"
		},
		{
			"resourceKey": "app.typenameRequestedDuty",
			"cultureCode": "nb-NO",
			"value": "Forespurt vakt"
		},
		{
			"resourceKey": "app.typenameTime",
			"cultureCode": "nb-NO",
			"value": "Registrert tid"
		},
		{
			"resourceKey": "app.typeText",
			"cultureCode": "nb-NO",
			"value": "Type"
		},
		{
			"resourceKey": "app.unCheckAll",
			"cultureCode": "nb-NO",
			"value": "Opphev alle"
		},
		{
			"resourceKey": "app.userNotAuthenticated",
			"cultureCode": "nb-NO",
			"value": "Brukeren er ikke godkjent for å bruke denne applikasjonen."
		},
		{
			"resourceKey": "app.validationErrorForgotPasswordText",
			"cultureCode": "nb-NO",
			"value": "Vennligst fyll inn firma og e-postadresse for å motta instruksjoner for å resette passordet."
		},
		{
			"resourceKey": "app.validationErrorTitle",
			"cultureCode": "nb-NO",
			"value": "Valideringsfeil"
		},
		{
			"resourceKey": "app.weekText",
			"cultureCode": "nb-NO",
			"value": "Uke"
		},
		{
			"resourceKey": "app.yearText",
			"cultureCode": "nb-NO",
			"value": "År"
		},
		{
			"resourceKey": "app.yes",
			"cultureCode": "nb-NO",
			"value": "Ja"
		},
		{
			"resourceKey": "LocalizationKey: Errors_Authorization_401",
			"cultureCode": "nb-NO",
			"value": "Bruker er ikke autorisert."
		},
		{
			"resourceKey": "Errors_CouldNotFindEmployeeByEmailAddress",
			"cultureCode": "nb-NO",
			"value": "Fant ingen brukere med epostadressen du oppga."
		},
		{
			"resourceKey": "Errors_CouldNotFindEmployeeForActiveDirectoryAuthentication",
			"cultureCode": "nb-NO",
			"value": "Fant ingen ansatte tilknyttet din identitet."
		},
		{
			"resourceKey": "Errors_CouldNotFindHelpHtml",
			"cultureCode": "nb-NO",
			"value": "Fant ikke hjelpefilen."
		},
		{
			"resourceKey": "Errors_DatabaseError",
			"cultureCode": "nb-NO",
			"value": "Det oppsto en databasefeil."
		},
		{
			"resourceKey": "Errors_DutyWishConflictsWithExistingDutyWish",
			"cultureCode": "nb-NO",
			"value": "Vaktønsket kolliderer med et allerede eksisterende vaktønske."
		},
		{
			"resourceKey": "Errors_EmployeeDoesNotHaveAccessToManualAdditions",
			"cultureCode": "nb-NO",
			"value": "Du har ikke tilgang til å gjøre dette."
		},
		{
			"resourceKey": "Errors_EmployeeDoesNotHaveAccessToUpdatePersonalInformation",
			"cultureCode": "nb-NO",
			"value": "Du har ikke tilgang til å gjøre endringer."
		},
		{
			"resourceKey": "Errors_EmployeeNotActive",
			"cultureCode": "nb-NO",
			"value": "Ingen tilgang til Min Capitech (deaktivert)."
		},
		{
			"resourceKey": "Errors_FromDateIsAfterToDate",
			"cultureCode": "nb-NO",
			"value": "Spesifisert fra-dato er etter til-dato."
		},
		{
			"resourceKey": "Errors_FromDateIsBeforeCloseDate",
			"cultureCode": "nb-NO",
			"value": "Registreringsdato er før siste dag du har tilgang til å registrere."
		},
		{
			"resourceKey": "Errors_InvalidAbsenceCode",
			"cultureCode": "nb-NO",
			"value": "Ugyldig fraværskode."
		},
		{
			"resourceKey": "Errors_InvalidAccessToken",
			"cultureCode": "nb-NO",
			"value": "Tilgangen din er utløpt. Vennligst forsøk å logge inn på nytt."
		},
		{
			"resourceKey": "Errors_InvalidDate",
			"cultureCode": "nb-NO",
			"value": "Dato er spesifisert i et ugyldig format."
		},
		{
			"resourceKey": "Errors_InvalidPinCode",
			"cultureCode": "nb-NO",
			"value": "Ugyldig PIN-kode."
		},
		{
			"resourceKey": "Errors_InvalidRefreshToken",
			"cultureCode": "nb-NO",
			"value": "Tilgangen din er utløpt. Vennligst forsøk å logge inn på nytt."
		},
		{
			"resourceKey": "Errors_InvalidReportId",
			"cultureCode": "nb-NO",
			"value": "Fant ikke rapporten. Den kan ha blitt fjernet eller deaktivert."
		},
		{
			"resourceKey": "Errors_InvalidSystemLicense",
			"cultureCode": "nb-NO",
			"value": "Ugyldig system-lisens."
		},
		{
			"resourceKey": "Errors_InvalidToken",
			"cultureCode": "nb-NO",
			"value": "En feil oppsto ved autentisering mot server."
		},
		{
			"resourceKey": "Errors_InvalidUsernameOrPassword",
			"cultureCode": "nb-NO",
			"value": "Ugyldig brukernavn eller passord."
		},
		{
			"resourceKey": "Errors_InvalidZipCode",
			"cultureCode": "nb-NO",
			"value": "Serveren vet ikke hvilket sted dette postnummeret hører til."
		},
		{
			"resourceKey": "Errors_InvalidZipCodeFormat",
			"cultureCode": "nb-NO",
			"value": "Ugyldig postnummer. Postnummeret må være et firesifret tall mellom 0000-9999."
		},
		{
			"resourceKey": "Errors_IsOverlappingAnotherRegistration",
			"cultureCode": "nb-NO",
			"value": "Registreringen overlapper en annen registrering."
		},
		{
			"resourceKey": "Errors_IsViolatingBackInTimeRule",
			"cultureCode": "nb-NO",
			"value": "Du har ikke tilgang til å registrere så langt bak i tid."
		},
		{
			"resourceKey": "Errors_IsViolatingNumberOfDaysBackInTimeRegisteringIsAllowed",
			"cultureCode": "nb-NO",
			"value": "Du har ikke tilgang til å registrere så langt bak i tid."
		},
		{
			"resourceKey": "Errors_IsViolatingRegistrationBan",
			"cultureCode": "nb-NO",
			"value": "Du har ikke tilgang til å registrere"
		},
		{
			"resourceKey": "Errors_IsViolatingRegistrationCloseDate",
			"cultureCode": "nb-NO",
			"value": "Registreringer på denne datoen er lukket."
		},
		{
			"resourceKey": "Errors_MissingArgument",
			"cultureCode": "nb-NO",
			"value": "En feil har oppstått."
		},
		{
			"resourceKey": "Errors_MultipleEmployeesWithEmailAddress",
			"cultureCode": "nb-NO",
			"value": "Epostadressen er i bruk av flere enn én person."
		},
		{
			"resourceKey": "Errors_NoTimeTransactionsToUpdate",
			"cultureCode": "nb-NO",
			"value": "Fant ingen timetransaksjoner å oppdatere."
		},
		{
			"resourceKey": "Errors_SmtpError",
			"cultureCode": "nb-NO",
			"value": "En feil oppsto under tilkobling til epost-serveren."
		},
		{
			"resourceKey": "Errors_TimeCategoryIsNotAvaliableForManualAddition",
			"cultureCode": "nb-NO",
			"value": "Tidskategorien er ikke tilgjengelig for manuelle tillegg."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsMissingRequiredFields",
			"cultureCode": "nb-NO",
			"value": "Et obligatorisk felt mangler verdi."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsOverlappingAnotherRegistration",
			"cultureCode": "nb-NO",
			"value": "Timetransaksjonen krasjer med en annen registrering."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsViolatingNumberOfDaysBackInTimeRegisteringIsAllowed",
			"cultureCode": "nb-NO",
			"value": "Registreringsdato er før siste dag du har tilgang til å registrere."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsViolatingRegistrationCloseDate",
			"cultureCode": "nb-NO",
			"value": "Registreringsdato er før siste dag du har tilgang til å registrere."
		},
		{
			"resourceKey": "Errors_UserOrIpIsBlocked",
			"cultureCode": "nb-NO",
			"value": "For mange mislykkede innloggingsforsøk. Vennligst prøv igjen litt senere."
		}
	],
	"en-EN": [
		{
			"resourceKey": "app.absenceText",
			"cultureCode": "en-EN",
			"value": "Absence"
		},
		{
			"resourceKey": "app.actionsHeading",
			"cultureCode": "en-EN",
			"value": "Actions"
		},
		{
			"resourceKey": "app.add",
			"cultureCode": "en-EN",
			"value": "Add"
		},
		{
			"resourceKey": "app.amountText",
			"cultureCode": "en-EN",
			"value": "Quantity"
		},
		{
			"resourceKey": "app.apiTimeoutTitle",
			"cultureCode": "en-EN",
			"value": "Time out"
		},
		{
			"resourceKey": "app.btnAdd",
			"cultureCode": "en-EN",
			"value": "Add"
		},
		{
			"resourceKey": "app.btnAskAbsence",
			"cultureCode": "en-EN",
			"value": "Ask absence"
		},
		{
			"resourceKey": "app.btnDelete",
			"cultureCode": "en-EN",
			"value": "X"
		},
		{
			"resourceKey": "app.btnEdit",
			"cultureCode": "en-EN",
			"value": "Edit"
		},
		{
			"resourceKey": "app.btnRegisterHours",
			"cultureCode": "en-EN",
			"value": "Register hours"
		},
		{
			"resourceKey": "app.btnRegisterHoursIn",
			"cultureCode": "en-EN",
			"value": "In"
		},
		{
			"resourceKey": "app.btnRegisterHoursOut",
			"cultureCode": "en-EN",
			"value": "Out"
		},
		{
			"resourceKey": "app.btnSave",
			"cultureCode": "en-EN",
			"value": "Save"
		},
		{
			"resourceKey": "app.btnSendMessage",
			"cultureCode": "en-EN",
			"value": "Send message"
		},
		{
			"resourceKey": "app.btnShow",
			"cultureCode": "en-EN",
			"value": "Details"
		},
		{
			"resourceKey": "app.cancel",
			"cultureCode": "en-EN",
			"value": "Cancel"
		},
		{
			"resourceKey": "app.checkAll",
			"cultureCode": "en-EN",
			"value": "Check all"
		},
		{
			"resourceKey": "app.close",
			"cultureCode": "en-EN",
			"value": "Close"
		},
		{
			"resourceKey": "app.confirmDeletionTitle",
			"cultureCode": "en-EN",
			"value": "Confirm deletion"
		},
		{
			"resourceKey": "app.currentDateText",
			"cultureCode": "en-EN",
			"value": "Selected date"
		},
		{
			"resourceKey": "app.dateText",
			"cultureCode": "en-EN",
			"value": "Date"
		},
		{
			"resourceKey": "app.dayText",
			"cultureCode": "en-EN",
			"value": "Day"
		},
		{
			"resourceKey": "app.delete",
			"cultureCode": "en-EN",
			"value": "Delete"
		},
		{
			"resourceKey": "app.departmentText",
			"cultureCode": "en-EN",
			"value": "Department"
		},
		{
			"resourceKey": "app.description",
			"cultureCode": "en-EN",
			"value": "Description"
		},
		{
			"resourceKey": "app.detailsTitle",
			"cultureCode": "en-EN",
			"value": "Details"
		},
		{
			"resourceKey": "app.dutyText",
			"cultureCode": "en-EN",
			"value": "Duty"
		},
		{
			"resourceKey": "app.dutyWishPeriodsText",
			"cultureCode": "en-EN",
			"value": "Period duty wish"
		},
		{
			"resourceKey": "app.dutyWishText",
			"cultureCode": "en-EN",
			"value": "Vacant duty wish"
		},
		{
			"resourceKey": "app.false",
			"cultureCode": "en-EN",
			"value": "No"
		},
		{
			"resourceKey": "app.forgotPasswordInfoText",
			"cultureCode": "en-EN",
			"value": "Select your company and enter your email address and we will send you a link to reset your password."
		},
		{
			"resourceKey": "app.forgotPasswordQuestion",
			"cultureCode": "en-EN",
			"value": "Forgot password?"
		},
		{
			"resourceKey": "app.forgotPasswordRequestedText",
			"cultureCode": "en-EN",
			"value": "Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder."
		},
		{
			"resourceKey": "app.fromDateLabel",
			"cultureCode": "en-EN",
			"value": "From date"
		},
		{
			"resourceKey": "app.fromTime",
			"cultureCode": "en-EN",
			"value": "Time (from)"
		},
		{
			"resourceKey": "app.hoursAndExtraRates",
			"cultureCode": "en-EN",
			"value": "Hours & extra rates"
		},
		{
			"resourceKey": "app.hoursText",
			"cultureCode": "en-EN",
			"value": "Hours"
		},
		{
			"resourceKey": "app.informationText",
			"cultureCode": "en-EN",
			"value": "Information"
		},
		{
			"resourceKey": "app.informationTitle",
			"cultureCode": "en-EN",
			"value": "Information"
		},
		{
			"resourceKey": "app.licenseInvalidText",
			"cultureCode": "en-EN",
			"value": "Invalid system license."
		},
		{
			"resourceKey": "app.licenseTitle",
			"cultureCode": "en-EN",
			"value": "License information"
		},
		{
			"resourceKey": "app.loading",
			"cultureCode": "en-EN",
			"value": "Loading My Capitech…"
		},
		{
			"resourceKey": "app.login.btnLogin",
			"cultureCode": "en-EN",
			"value": "Log in"
		},
		{
			"resourceKey": "app.login.placeholderPassword",
			"cultureCode": "en-EN",
			"value": "Password"
		},
		{
			"resourceKey": "app.login.placeholderUsername",
			"cultureCode": "en-EN",
			"value": "Username"
		},
		{
			"resourceKey": "app.login.rememberLogin",
			"cultureCode": "en-EN",
			"value": "Remember login"
		},
		{
			"resourceKey": "app.messagesText",
			"cultureCode": "en-EN",
			"value": "Messages"
		},
		{
			"resourceKey": "app.messageText",
			"cultureCode": "en-EN",
			"value": "Message"
		},
		{
			"resourceKey": "app.my",
			"cultureCode": "en-EN",
			"value": "My"
		},
		{
			"resourceKey": "app.name",
			"cultureCode": "en-EN",
			"value": "My Capitech"
		},
		{
			"resourceKey": "app.no",
			"cultureCode": "en-EN",
			"value": "No"
		},
		{
			"resourceKey": "app.noOptionToChoose",
			"cultureCode": "en-EN",
			"value": "No available options"
		},
		{
			"resourceKey": "app.notes",
			"cultureCode": "en-EN",
			"value": "Notes"
		},
		{
			"resourceKey": "app.noticeText",
			"cultureCode": "en-EN",
			"value": "Notice/comment"
		},
		{
			"resourceKey": "app.openFilter",
			"cultureCode": "en-EN",
			"value": "Open filter"
		},
		{
			"resourceKey": "app.planNumberText",
			"cultureCode": "en-EN",
			"value": "Work number"
		},
		{
			"resourceKey": "app.pleaseSelect",
			"cultureCode": "en-EN",
			"value": "Please select…"
		},
		{
			"resourceKey": "app.registerText",
			"cultureCode": "en-EN",
			"value": "Register"
		},
		{
			"resourceKey": "app.returnToSignInQuestion",
			"cultureCode": "en-EN",
			"value": "Return to sign in?"
		},
		{
			"resourceKey": "app.sendPasswordResetEmailButtonText",
			"cultureCode": "en-EN",
			"value": "Send password reset email"
		},
		{
			"resourceKey": "app.settings.labelApiUrl",
			"cultureCode": "en-EN",
			"value": "API-path"
		},
		{
			"resourceKey": "app.settings.labelLanguage",
			"cultureCode": "en-EN",
			"value": "Language"
		},
		{
			"resourceKey": "app.settings.saveButton",
			"cultureCode": "en-EN",
			"value": "Save settings"
		},
		{
			"resourceKey": "app.settings.settingsDescription",
			"cultureCode": "en-EN",
			"value": "Change the settings here to match your needs. For support visit <a href=\"http://support.capitech.no\" target=\"_blank\">Capitech support</a>."
		},
		{
			"resourceKey": "app.settings.settingsText",
			"cultureCode": "en-EN",
			"value": "Settings"
		},
		{
			"resourceKey": "app.settings.settingsTitle",
			"cultureCode": "en-EN",
			"value": "Your app-<strong>settings</strong>"
		},
		{
			"resourceKey": "app.settings.validationText",
			"cultureCode": "en-EN",
			"value": "The terminal was successful validated and you can start to use it."
		},
		{
			"resourceKey": "app.settings.validationTitle",
			"cultureCode": "en-EN",
			"value": "Validation successful!"
		},
		{
			"resourceKey": "app.settingsBtn",
			"cultureCode": "en-EN",
			"value": "Settings"
		},
		{
			"resourceKey": "app.statusText",
			"cultureCode": "en-EN",
			"value": "Status"
		},
		{
			"resourceKey": "app.systemErrorMsg",
			"cultureCode": "en-EN",
			"value": "An unknown system error occurred, if the error persist contact your system administrator."
		},
		{
			"resourceKey": "app.systemErrorTitle",
			"cultureCode": "en-EN",
			"value": "System error"
		},
		{
			"resourceKey": "app.textText",
			"cultureCode": "en-EN",
			"value": "Text"
		},
		{
			"resourceKey": "app.timeoutErrorMsg",
			"cultureCode": "en-EN",
			"value": "A timeout occurred, please try again."
		},
		{
			"resourceKey": "app.timeoutErrorTitle",
			"cultureCode": "en-EN",
			"value": "Timeout"
		},
		{
			"resourceKey": "app.timeText",
			"cultureCode": "en-EN",
			"value": "Time"
		},
		{
			"resourceKey": "app.toDateLabel",
			"cultureCode": "en-EN",
			"value": "To date"
		},
		{
			"resourceKey": "app.toTime",
			"cultureCode": "en-EN",
			"value": "Time (to)"
		},
		{
			"resourceKey": "app.true",
			"cultureCode": "en-EN",
			"value": "Yes"
		},
		{
			"resourceKey": "app.tryAgainBtn",
			"cultureCode": "en-EN",
			"value": "Try again"
		},
		{
			"resourceKey": "app.typenameAbscense",
			"cultureCode": "en-EN",
			"value": "Absence"
		},
		{
			"resourceKey": "app.typenameAvailableDuty",
			"cultureCode": "en-EN",
			"value": "Available duty"
		},
		{
			"resourceKey": "app.typenameDutyWish",
			"cultureCode": "en-EN",
			"value": "Duty wish"
		},
		{
			"resourceKey": "app.typenamePlannedDuty",
			"cultureCode": "en-EN",
			"value": "Planned duty"
		},
		{
			"resourceKey": "app.typenameRequestedDuty",
			"cultureCode": "en-EN",
			"value": "Requested duty"
		},
		{
			"resourceKey": "app.typenameTime",
			"cultureCode": "en-EN",
			"value": "Registered hours"
		},
		{
			"resourceKey": "app.typeText",
			"cultureCode": "en-EN",
			"value": "Type"
		},
		{
			"resourceKey": "app.unCheckAll",
			"cultureCode": "en-EN",
			"value": "Uncheck all"
		},
		{
			"resourceKey": "app.userNotAuthenticated",
			"cultureCode": "en-EN",
			"value": "User are not authenticated to use this application."
		},
		{
			"resourceKey": "app.validationErrorForgotPasswordText",
			"cultureCode": "en-EN",
			"value": "Please select a company and enter your e-mail to recieve password reset instructions."
		},
		{
			"resourceKey": "app.validationErrorTitle",
			"cultureCode": "en-EN",
			"value": "Validation error"
		},
		{
			"resourceKey": "app.weekText",
			"cultureCode": "en-EN",
			"value": "Week"
		},
		{
			"resourceKey": "app.yearText",
			"cultureCode": "en-EN",
			"value": "Year"
		},
		{
			"resourceKey": "app.yes",
			"cultureCode": "en-EN",
			"value": "Yes"
		},
		{
			"resourceKey": "LocalizationKey: Errors_Authorization_401",
			"cultureCode": "en-EN",
			"value": "User not authorized."
		},
		{
			"resourceKey": "Errors_CouldNotFindEmployeeByEmailAddress",
			"cultureCode": "en-EN",
			"value": "Could not find any users with the specified email address."
		},
		{
			"resourceKey": "Errors_CouldNotFindEmployeeForActiveDirectoryAuthentication",
			"cultureCode": "en-EN",
			"value": "Could not find an employee connected to your identity."
		},
		{
			"resourceKey": "Errors_CouldNotFindHelpHtml",
			"cultureCode": "en-EN",
			"value": "Could not load the help file."
		},
		{
			"resourceKey": "Errors_DatabaseError",
			"cultureCode": "en-EN",
			"value": "A database error has occurred."
		},
		{
			"resourceKey": "Errors_DutyWishConflictsWithExistingDutyWish",
			"cultureCode": "en-EN",
			"value": "The duty wish conflicts with an already existing duty wish."
		},
		{
			"resourceKey": "Errors_EmployeeDoesNotHaveAccessToManualAdditions",
			"cultureCode": "en-EN",
			"value": "You do not have access to do this."
		},
		{
			"resourceKey": "Errors_EmployeeDoesNotHaveAccessToUpdatePersonalInformation",
			"cultureCode": "en-EN",
			"value": "You do not have access to make changes."
		},
		{
			"resourceKey": "Errors_EmployeeNotActive",
			"cultureCode": "en-EN",
			"value": "No access to My Capitech (inactive)."
		},
		{
			"resourceKey": "Errors_FromDateIsAfterToDate",
			"cultureCode": "en-EN",
			"value": "Specified from-date is after specified to-date."
		},
		{
			"resourceKey": "Errors_FromDateIsBeforeCloseDate",
			"cultureCode": "en-EN",
			"value": "The registration date is before the last day you have access to register."
		},
		{
			"resourceKey": "Errors_InvalidAbsenceCode",
			"cultureCode": "en-EN",
			"value": "Invalid absence code."
		},
		{
			"resourceKey": "Errors_InvalidAccessToken",
			"cultureCode": "en-EN",
			"value": "Your access has expired. Please try to login again."
		},
		{
			"resourceKey": "Errors_InvalidDate",
			"cultureCode": "en-EN",
			"value": "The provided date is not in a correct format."
		},
		{
			"resourceKey": "Errors_InvalidPinCode",
			"cultureCode": "en-EN",
			"value": "Invalid PIN code."
		},
		{
			"resourceKey": "Errors_InvalidRefreshToken",
			"cultureCode": "en-EN",
			"value": "Your access has expired. Please try to login again."
		},
		{
			"resourceKey": "Errors_InvalidReportId",
			"cultureCode": "en-EN",
			"value": "Could not find the report. It may have been removed or deactivated."
		},
		{
			"resourceKey": "Errors_InvalidSystemLicense",
			"cultureCode": "en-EN",
			"value": "Invalid system license."
		},
		{
			"resourceKey": "Errors_InvalidToken",
			"cultureCode": "en-EN",
			"value": "An error occurred while authenticating with the server."
		},
		{
			"resourceKey": "Errors_InvalidUsernameOrPassword",
			"cultureCode": "en-EN",
			"value": "Invalid username or password."
		},
		{
			"resourceKey": "Errors_InvalidZipCode",
			"cultureCode": "en-EN",
			"value": "The server does not know which place this zip code belongs to."
		},
		{
			"resourceKey": "Errors_InvalidZipCodeFormat",
			"cultureCode": "en-EN",
			"value": "Invalid zip code format. The zip code must be a four-letter number between 0000-9999."
		},
		{
			"resourceKey": "Errors_IsOverlappingAnotherRegistration",
			"cultureCode": "en-EN",
			"value": "The registration overlaps another registration."
		},
		{
			"resourceKey": "Errors_IsViolatingBackInTimeRule",
			"cultureCode": "en-EN",
			"value": "You do not have access to create registrations this far back in time."
		},
		{
			"resourceKey": "Errors_IsViolatingNumberOfDaysBackInTimeRegisteringIsAllowed",
			"cultureCode": "en-EN",
			"value": "You do not have access to create registrations this far back in time."
		},
		{
			"resourceKey": "Errors_IsViolatingRegistrationBan",
			"cultureCode": "en-EN",
			"value": "You don't have access to create registrations."
		},
		{
			"resourceKey": "Errors_IsViolatingRegistrationCloseDate",
			"cultureCode": "en-EN",
			"value": "This date is closed for new registrations."
		},
		{
			"resourceKey": "Errors_MissingArgument",
			"cultureCode": "en-EN",
			"value": "An error has occurred."
		},
		{
			"resourceKey": "Errors_MultipleEmployeesWithEmailAddress",
			"cultureCode": "en-EN",
			"value": "The email address is in use by more than one person."
		},
		{
			"resourceKey": "Errors_NoTimeTransactionsToUpdate",
			"cultureCode": "en-EN",
			"value": "Could not find any time transactions to update."
		},
		{
			"resourceKey": "Errors_SmtpError",
			"cultureCode": "en-EN",
			"value": "An error occurred while communicating with the email server."
		},
		{
			"resourceKey": "Errors_TimeCategoryIsNotAvaliableForManualAddition",
			"cultureCode": "en-EN",
			"value": "The time category is not avaliable for manual additions."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsMissingRequiredFields",
			"cultureCode": "en-EN",
			"value": "A required field is missing value."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsOverlappingAnotherRegistration",
			"cultureCode": "en-EN",
			"value": "The time transaction conflicts with another registration."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsViolatingNumberOfDaysBackInTimeRegisteringIsAllowed",
			"cultureCode": "en-EN",
			"value": "The registration date is before the last day you have access to register."
		},
		{
			"resourceKey": "Errors_TimeTransactionValidationError_IsViolatingRegistrationCloseDate",
			"cultureCode": "en-EN",
			"value": "The registration date is before the last day you have access to register."
		},
		{
			"resourceKey": "Errors_UserOrIpIsBlocked",
			"cultureCode": "en-EN",
			"value": "Too many invalid logins. Please try again later."
		}
	]
};

function translateGUI($parentElm) {
	$parentElm = typeof $parentElm !== 'undefined' ? $parentElm : $('body');
	
	$parentElm.find('*[data-l10n-id]').each(function(index, obj) {
		var newValue,
			$obj = $(obj),
			defaultValue = '',
			resourceKey = $obj.data('l10n-id'),
			elmTagName = $obj.prop('tagName').toUpperCase();
		
		if (elmTagName === 'INPUT' || elmTagName === 'TEXTAREA') {
			defaultValue = $obj.attr('placeholder');
			newValue = getResource(resourceKey, defaultValue, elmTagName);
			$obj.attr('placeholder', newValue);
		} else {
			defaultValue = $obj.html();
			newValue = getResource(resourceKey, defaultValue, elmTagName);
			$obj.html(newValue);
		}
	});
}

function getResource(key, defaultValue, elmTagName, language) {
	elmTagName = typeof elmTagName !== 'undefined' ? elmTagName : 'DIV';
	language = typeof language !== 'undefined' ? language : _appSettingsObj.language;
	
	var translated = '';
	var bHasTranslation = true;
	
	elmTagName = elmTagName.toUpperCase();
	
	try {
		translated = findObjectInArray(languages[language], "resourceKey", key).value;
		if (translated == null) {
			translated = defaultValue;
			bHasTranslation = false;
			// translated = key;
		}
	} catch (err) {
		translated = defaultValue;
		bHasTranslation = false;
		// translated = key;
	}
	
	// Set returned value to key if it's empty or debugging is activated
	if (translated == null || translated == 'undefined' || translated == '' || _appSettingsObj.bDebug == 'true') {
		if (_appSettingsObj.bDebug == 'true' && bHasTranslation === false) {
			if (elmTagName === 'INPUT' || elmTagName === 'TEXTAREA' || elmTagName === 'TITLE') {
				translated = 'resource-key-missing: ' + key;
			} else {
				translated = '<span class="ct-resource-key ct-resource-key-missing">' + key + '</span>';
			}
		} else if (_appSettingsObj.bDebug == 'true' && bHasTranslation === true) {
			if (elmTagName === 'INPUT' || elmTagName === 'TEXTAREA' || elmTagName === 'TITLE') {
				translated = 'resource-key-exists: ' + key;
			} else {
				translated = '<span class="ct-resource-key">' + key + '</span>';
			}
		} else {
			translated = key;
		}
		
	}
	
	return translated;
}